"use client";

import { c as _c } from "react/compiler-runtime";
import type { Offer } from "@local/offer/src/types";
import { firstNonEmpty } from "@local/utils/src/firstNonEmpty";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import Image from "next/image";
import { useSearchParams } from "next/navigation";
import { Fragment, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import CssCarousel from "../../ui/CssCarousel";
import { Modal } from "../../ui/Modal";
export const CarouselWrapper = t0 => {
  const $ = _c(38);
  const {
    slides,
    product,
    includeVariantImage,
    priority
  } = t0;
  const [showModal, setShowModal] = useState(false);
  const [carouselSelectedItem, setCarouselSelectedItem] = useState(0);
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("item_id");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const itemId = t1;
  let t2;
  bb0: {
    if (!itemId || !product || !includeVariantImage) {
      t2 = slides;
      break bb0;
    }
    let t3;
    if ($[2] !== product.skuLists || $[3] !== product.skus || $[4] !== product.type) {
      t3 = product.type === "BUNDLE" ? product.skuLists.flatMap(_temp) : product.skus;
      $[2] = product.skuLists;
      $[3] = product.skus;
      $[4] = product.type;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    const allSkus = t3;
    let t4;
    if ($[6] !== allSkus || $[7] !== itemId) {
      let t5;
      if ($[9] !== itemId) {
        t5 = sku => sku.legacyId === itemId || sku.attributes.some(attr => attr.name === "payloadId" && attr.value === itemId) || sku.id === itemId || sku.name === itemId;
        $[9] = itemId;
        $[10] = t5;
      } else {
        t5 = $[10];
      }
      t4 = allSkus.find(t5);
      $[6] = allSkus;
      $[7] = itemId;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    const matchingSku = t4;
    const primaryImage = matchingSku?.media.default?.[0];
    if (!primaryImage) {
      t2 = slides;
      break bb0;
    }
    const imageAlreadyExists = slides?.some(slide => slide.image?.url === primaryImage.url);
    if (imageAlreadyExists) {
      t2 = slides;
      break bb0;
    }
    let t5;
    if ($[11] !== itemId || $[12] !== primaryImage) {
      t5 = {
        ...primaryImage,
        instanceId: itemId
      };
      $[11] = itemId;
      $[12] = primaryImage;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== itemId || $[15] !== t5) {
      t6 = {
        title: itemId,
        id: itemId,
        image: t5
      };
      $[14] = itemId;
      $[15] = t5;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    const newSlide = t6;
    let t7;
    if ($[17] !== slides) {
      t7 = slides ?? [];
      $[17] = slides;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    let t8;
    if ($[19] !== newSlide || $[20] !== t7) {
      t8 = [newSlide, ...t7];
      $[19] = newSlide;
      $[20] = t7;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    t2 = t8;
  }
  const actualSlides = t2;
  let t3;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setShowModal(true);
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  let t4;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      base: 1,
      sm: 1,
      md: 1
    };
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== actualSlides || $[25] !== priority) {
    t5 = actualSlides?.map((slide_0, i) => <Image key={`product-modal-${slide_0?.image?.url}-${i}`} src={getCdnUrl({
      src: slide_0?.image?.url ?? "",
      width: 1024
    })} alt={firstNonEmpty([slide_0?.image?.alt, slide_0?.title], `Slide ${i + 1}`)} width={1024} height={1024} sizes="(max-width: 768px) 100vw, 50vw" className="cursor-pointer" priority={!!priority && i === 0} />);
    $[24] = actualSlides;
    $[25] = priority;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== t5) {
    t6 = <CssCarousel showArrows={true} showThumbs={true} onClick={t3} afterSlide={setCarouselSelectedItem} slidesPerView={t4}>{t5}</CssCarousel>;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== actualSlides || $[30] !== carouselSelectedItem || $[31] !== showModal) {
    t7 = showModal ? createPortal(<Modal open={true} toggle={() => {
      setShowModal(!showModal);
    }}><CssCarousel showArrows={true} showThumbs={true} onClick={() => setShowModal(true)} initialSlide={carouselSelectedItem} slidesPerView={{
        base: 1,
        sm: 1,
        md: 1
      }}>{actualSlides?.map(_temp2)}</CssCarousel></Modal>, document.body) : <Fragment />;
    $[29] = actualSlides;
    $[30] = carouselSelectedItem;
    $[31] = showModal;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  let t8;
  if ($[33] !== t7) {
    t8 = <>{t7}</>;
    $[33] = t7;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== t6 || $[36] !== t8) {
    t9 = <div>{t6}{t8}</div>;
    $[35] = t6;
    $[36] = t8;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  return t9;
};
function _temp(skuList) {
  return skuList.skus;
}
function _temp2(slide_1, i_0) {
  return <Image key={`product-modal-${slide_1?.image?.url}-${i_0}`} src={getCdnUrl({
    src: slide_1?.image?.url ?? "",
    width: 1024
  })} alt={`product modal image ${i_0 + 1}`} width={1024} height={1024} sizes="100vw" className="cursor-pointer" />;
}